import { IVideoOverlay } from '@vbrick/vbrick-player';

export enum VIDEO_OVERLAY_TYPE {
	VIEWER_ID = 'ViewerId'
}

export type VideoOverlay = IVideoOverlay & {
	type?: VIDEO_OVERLAY_TYPE
};
